var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHourglass48Filled = function SvgIconHourglass48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7 16.2v-2.6c0-2.92-2.38-5.3-5.3-5.3h-8.8a5.31 5.31 0 0 0-5.3 5.3v2.6c0 1.66.79 3.24 2.12 4.24L21.17 24l-4.74 3.56c-1.33 1-2.12 2.58-2.12 4.24v2.6c0 2.92 2.38 5.3 5.3 5.3h8.8c2.92 0 5.3-2.38 5.3-5.3v-2.6c0-1.66-.79-3.24-2.12-4.24L26.84 24l4.75-3.56c1.33-1 2.12-2.58 2.12-4.24h-.01Z",
    fill: "current"
  })));
};
export default SvgIconHourglass48Filled;